import { backUrl } from "../utils/backURL";
import { withAuthCredentials } from "../utils/authFetchOptions";

export const uploadImage = async (formData) => {
  const uploadReq = await fetch(`${backUrl}/fileUpload/uploadImage`, withAuthCredentials({
    method: "POST",
    body: formData,
  }));
  const uploadRes = await uploadReq.json();
  return uploadRes;
};

export const uploadFile = async (formData) => {
  const uploadReq = await fetch(`${backUrl}/fileUpload/uploadFile`, withAuthCredentials({
    method: "POST",
    body: formData,
  }));
  const uploadRes = await uploadReq.json();
  return uploadRes;
};
